"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useMemo } from "react";

import { trackAnalyticsApiEvent } from "@/lib/analytics";
import { DEFAULT_LOCALE, getLocaleFromPathname } from "@/lib/i18n/locales";
import { withSeoLocalePath } from "@/lib/i18n/seo-paths";

type RelatedTool = {
  slug: string;
  label: string;
};

export default function RelatedTools(props: { title: string; tools: RelatedTool[] }) {
  const pathname = usePathname();
  const locale = useMemo(() => (pathname ? getLocaleFromPathname(pathname) : DEFAULT_LOCALE), [pathname]);
  const localizeHref = (href: string) => withSeoLocalePath(locale, href);

  return (
    <div className="py-12 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4">
        <h3 className="text-2xl font-bold mb-6">{props.title}</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {props.tools.map(tool => (
            <Link
              key={tool.slug}
              href={localizeHref(`/tools/${tool.slug}`)}
              className="text-blue-600 hover:underline"
              onClick={() => trackAnalyticsApiEvent("related_tool_clicked", { tool_slug: tool.slug, tool_name: tool.label })}
            >
              {tool.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
